import React from 'react';

const CTASection = ({ onContactClick }) => (
  <section className="px-4 sm:px-5 md:px-10 lg:px-20 xl:px-32 w-full">
    <div className="max-w-[1200px] mx-auto h-auto lg:h-[269px] text-center flex flex-col items-center">
      <h2 
        className="font-medium text-[22px] sm:text-[28px] md:text-[38px] lg:text-[45px] leading-[1.35] lg:leading-[65px] text-[#1A1A1A] mb-3 sm:mb-4"
        style={{
          textShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
          backdropFilter: 'blur(2px)'
        }}
      >
        Ready to Build a Smarter IT Foundation?
      </h2>
      <p className="font-normal text-[14px] sm:text-[18px] md:text-[22px] lg:text-[24px] leading-[1.5] lg:leading-[35px] text-[#1A1A1A] max-w-[581px] mb-6 sm:mb-8 px-2">
        Partner with Elowen IT to secure, manage, and scale your technology with confidence.
      </p>
      <button
        onClick={onContactClick}
        className="px-8 py-3 sm:py-4 text-[16px] sm:text-[18px] font-semibold text-white rounded-[8px] transition-all duration-200 hover:opacity-90 active:scale-95"
        style={{
          background: 'linear-gradient(274.68deg, #F05736 -5.46%, #FBB12F 138.47%)',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        Get in Touch
      </button>
    </div>
  </section>
);

export default CTASection;
